export const SET_NAVIGATION_CONTEXT = 'SET_NAVIGATION_CONTEXT',
    CLOSE_SIDEBAR = 'CLOSE_SIDEBAR',
    OPEN_SIDEBAR = 'OPEN_SIDEBAR',
    TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

export function setNavigationContext(name, context) {
    return {
        type: SET_NAVIGATION_CONTEXT,
        payload: {
            [name]: context
        }
    };
};

export function closeSidebar() {
    return {type: CLOSE_SIDEBAR};
};

export function openSidebar() {
    return {type: OPEN_SIDEBAR};
};

export function toggleSidebar() {
    return {type: TOGGLE_SIDEBAR};
};


// WEBPACK FOOTER //
// ./src/actions/navigation.js